import {CollectionsType} from '@packages/systems/core/records/CollectionStateType';
import {NO_SEARCH_FIELD_SCHEMA} from '@packages/systems/cms/constants';
import Field from '@packages/systems/dynamo/records/Field';

export const maybeAddNoSearchFieldToCollections = (
  collections: CollectionsType
): CollectionsType =>
  collections.map((collection) => {
    const fields = collection.get('fields');
    return fields.some((field) => field.get('slug') === '_noSearch')
      ? collection
      : collection.update('fields', (existingFields) =>
          existingFields.push(Field(NO_SEARCH_FIELD_SCHEMA))
        );
  });
